const API_ENDPOINT = 'https://eixuxbz5h0.execute-api.us-east-1.amazonaws.com/latest/data';

/**
 * DashboardTrackingAPI contains a method to log in customers log ins into the reporting app
 *
 * @class DashboardTrackingAPI
 */
export default class DashboardTrackingAPI {
    static async trackLogin(email, username, aiChatName) {
        try {
            const method = 'POST';
            const headers = {
                'Content-Type': 'application/json',
                'X-Api-Key': "vQ7zdpOs4r4MtgGCHohfp8Ktd0gSuKsB55lTTZzd"
            };

            const body = JSON.stringify({
                email: email,
                id: username,
                ai_chat_name: aiChatName,
                origin: window.location.origin,
                app_name: "reports"
            });
            await fetch(API_ENDPOINT, { method, headers, body })
            return;
        } catch (error) {
            return;
        }
    }
}